import { Message } from "shared/components/Message";
import { userMessages } from "domain/user/userMessages";
import React, { VFC } from "react";

export const EmailChanged: VFC = () => <main>
    <h1 className="h2"><Message message={userMessages.emailSuccessfullyChangedTitle} /></h1>
    <p><Message message={userMessages.emailSuccessfullyChangedMessage} /></p>
</main>;
